module.exports = __webpack_public_path__ + "images/store_case_study/brandowl-pic1_67fc0e286d86e1f5ef639c9587ca2702.png";